<template>
  <div class="recordIndex">
    <!-- 当月的收入 -->
    <div class="flex_start mb">
      <div class="currentMonthIncome">
        <h3 class="flex_justify_center bg_blue"><img src="../../assets/dollar-sign.svg" />This Month Earning – {{recordData.data}}</h3>
        <p class="flex_justify_center">{{utils.numFormat(recordData.monthlySalary)}} (USD)</p>
      </div>
      <div class="currentMonthTeach">
        <h3 class="flex_justify_center bg_blue"><img src="../../assets/clock.svg" />Lesson Credit(s)</h3>
        <p class="flex_justify_center">{{recordData.monthlyHour}}</p>
      </div>
    </div>
    <!-- 当月的教学数据 -->

    <!-- 每月的收入 -->
      <el-table
      :data="monthData"
      style="width: 100%">
      <el-table-column
        prop="start_at"
        label="Month in Year">
      </el-table-column>
      <el-table-column
        prop="hour"
        label="Lesson Credit(s)">
      </el-table-column>
      <el-table-column
        prop="salary"
        label="Monthly Earning (USD)">
      <template slot-scope="scope">
          $ <span v-text="utils.numFormat(scope.row.salary)"></span>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      @current-change="handleCurrentChange"
      :current-page="pagenum"
      :page-size="pagesize"
      layout="prev, pager, next"
      :total="total">
    </el-pagination>
  </div>
</template>
<script>
export default {
  data () {
    return {
      recordData: {},
      monthData: [],
      total: 0,
      pagenum: 1, // 当前页码
      pagesize: 10 // 每页显示条数
    }
  },
  created () {
    this.getData()
  },
  methods: {
    getData () {
      this.$http.get('/tutor/api/monthlySalary?time=' + this.utils.timeZone()).then((res) => {
        if (res.data.code == 200) {
          this.recordData = res.data.data
        } else {
          this.$message({
            message: res.data.msg,
            type: 'warning'
          })
        }
      }).catch((error) => {
        console.log(error)
      })
      this.$http.get('/tutor/api/monthlyRecord?pagesize=' + this.pagesize + '&page=' + this.pagenum + '&time=' + this.utils.timeZone()).then((res) => {
        if (res.data.code == 200) {
          this.total = res.data.data.total
          this.monthData = res.data.data.datas
        } else {
          this.$message({
            message: res.data.msg,
            type: 'warning'
          })
        }
      }).catch((error) => {
        console.log(error)
      })
    },
    handleCurrentChange (val) {
      this.pagenum = val
      this.getData(this.pagenum)
    }
  }
}
</script>
<style lang="less" scoped>
  .recordIndex{
    .mb{
      margin-bottom: 40px;
    }
    .currentMonthIncome,.currentMonthTeach{
      margin-right:30px;
      h3{
        height:40px;
        padding:0 16px;
        border-radius: 5px 5px 0px 0px;
        font-weight: normal;
        img{
          width:20px;
          height:20px;
          margin-right:10px;
        }
      }
      p{
        font-size: 28px;
        height:69px;
        border: 1px solid #EDEDEE;
        border-radius: 0px 0px 5px 5px;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/views/record.vue